import React, { useEffect, useState } from 'react';
import { userAPI } from '../API/api';
import './leaderboard.css';
import Header from '../Header/header';

const Leaderboard = () => {
  const [elections, setElections] = useState([]);
  const [quarters, setQuarters] = useState([]);
  const [selectedQuarter, setSelectedQuarter] = useState('');
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let intervalId;
  
    const fetchLeaderboardData = async () => {
      try {
        const response = await userAPI.get('/vote/elections/log');
        const allElections = response.data;
  
        const allQuarters = [...new Set(allElections.map(e => e.quarter))];
        setQuarters(allQuarters);
        setSelectedQuarter(prev => prev || allQuarters[0]);
        setElections(allElections);
      
      } catch (error) {
        console.error('Error loading leaderboard data:', error);
      } finally {
        setLoading(false);
      }
    };
  
    // Initial fetch
    fetchLeaderboardData();
  
    // Set interval to fetch data every 60 seconds
    intervalId = setInterval(fetchLeaderboardData, 60000);
  
    // Clear interval on component unmount
    return () => clearInterval(intervalId);
  }, []);
  
  const filtered = elections.filter(e => e.quarter === selectedQuarter);

  return (
    <div className="leaderboard-container">
      <Header />
      <div className="leaderboard-header">
        <h2>Leaderboard</h2>
        <select
          value={selectedQuarter}
          onChange={(e) => setSelectedQuarter(e.target.value)}
          className="quarter-selector"
        >
          {quarters.map((q, i) => (
            <option key={i} value={q}>{q}</option>
          ))}
        </select>
      </div>

      {loading ? (
        <p>Loading leaderboard...</p>
      ) : (
        filtered.map((election) => (
          <div key={election.id} className="leaderboard-card animate">
            <h3>{election.election_name}</h3>
            <p><strong>Quarter:</strong> {election.quarter}</p>

            <table className="leaderboard-table">
              <thead>
                <tr>
                  <th>Candidate</th>
                  <th>Department</th>
                  <th>Votes</th>
                </tr>
              </thead>
              <tbody>
                {election.results
                  .filter((r) => r.name.trim() !== '')
                  .sort((a, b) => b.vote_count - a.vote_count)
                  .map((result, idx) => (
                    <tr key={result.id} className={idx === 0 ? 'top-rank' : ''}>
                      <td>{result.name}</td>
                      <td>{result.department_name}</td>
                      <td>{result.vote_count}</td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        ))
      )}
    </div>
  );
};

export default Leaderboard;
